import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "removeHTMLTags",
    standalone: false
})
export class RemoveHTMLTagsPipe implements PipeTransform {
    transform(value: string) {
        return value.replace(/<.*?>/g, "");
    }
}
